// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase : {
    apiKey: "AIzaSyBjn9OU9RQPpAZ6eLWNMgfiZnuBWIUeBus",
    authDomain: "cric-indo.firebaseapp.com",
    databaseURL: "https://cric-indo.firebaseio.com",
    projectId: "cric-indo",
    storageBucket: "",
    messagingSenderId: "772316912821",
    appId: "1:772316912821:web:e846fcbcf6325ad864b2fc"
  },
  lsKey: 'tZJaq72y3buBxQAPTPv4',
  SQUARE_ACCESS_TOKEN:'EAAAEMyER4UxO-XU3itXuNwD0ze1p2XjRU5gI_nl9h0qNeynoA8rZpoOiJ0UgxOm'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
